module.exports = __webpack_public_path__ + "static/don36-f8dc85454a2281b222e63cdf16d35e79.jpg";